import React from 'react'
import {FormControl,InputLabel,Select,MenuItem  } from '@material-ui/core';


const ComboBox = ({label,options,value,changeValue}) => 
{
  return <div style={{margin:"10px 0",padding:"5px"}} >
    <FormControl fullWidth>
    <Select 
    native
    value={value}
    onChange={e => changeValue(e.target.value)}
    variant="outlined"
    fullWidth
    labelId="demo-simple-select-label"
    id="demo-simple-select">
    {options.map(option => <option key={option.data.Nombre}>{option.data.Nombre}</option>)}
    </Select>
  </FormControl>
  </div>
   
}

export default ComboBox
